import { BaseModalController } from '@app/components/modals/base/base.modal-controller';
import { AuthService } from '@app/services/auth/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Injectable } from '@angular/core';

@Injectable()
export class EndSessionWarningModalController extends BaseModalController {
	constructor(modal: BsModalService, private auth: AuthService) {
		super(modal);
	}

	public init(): void {
		// this.auth.showSessionModal$
		// 	.pipe(takeUntil(this.unsubscribe))
		// 	.subscribe(() => this.launch(EndSessionWarningModalComponent));
	}
}
